
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.96 8.26c-.56-.58-.53-1.5.05-2.07L15.96.42a1.463 1.463 0 012.07.02L9.96 8.26zM.18 22.96a.6.6 0 00.84.87l1-.97-.84-.88-1 .98zm10.94-8.66l-3.41 3.32a10.96 10.96 0 01-3.61 2.39c.66-1.45 1.4-2.47 2.5-3.54l3.4-3.31-1.38-1.44-3.42 3.32a14.13 14.13 0 00-3.64 5.91l1.5 1.56a14.1 14.1 0 006.03-3.45l3.42-3.32-1.4-1.44zM20 2.95l-7.37 7.14 1.65 1.71 7.37-7.15c1.13-1.1-.55-2.77-1.65-1.7zm4 .85c0 .83-.32 1.67-.97 2.3l-8.8 8.53-4.44-4.58 8.8-8.54A3.2 3.2 0 0124 3.8z"}})])
          )
        }
      }
    